<script setup lang="ts">
    import { computed } from 'vue';

    const props = defineProps<{
        content?: string | null;
    }>();

    const simpleEntries = computed<[string, unknown][]>(() => {
        if (!props.content) return [];
        try {
            const json = JSON.parse(props.content);
            if (json && typeof json === 'object') {
                return Object.keys(json)
                    .filter((key) => typeof (json as any)[key] !== 'object')
                    .map((key) => [key, (json as any)[key]]);
            }
            return [];
        } catch {
            return [];
        }
    });

    const isJsonRenderable = computed(() => simpleEntries.value.length > 0);
</script>

<template>
    <template v-if="!content"></template>
    <template v-else-if="isJsonRenderable">
        <div
            v-for="[key, value] in simpleEntries"
            :key="key"
        >
            <b>{{ key }}:</b> {{ String(value) }}
        </div>
    </template>
    <template v-else>
        {{ content }}
    </template>
</template>
